// ==================================================================================
// Digital Approval System (DAS) - Reports Endpoints
// ==================================================================================
// API endpoint URL builders for the Reports module — the Workflow Summary
// dashboard and the five request-lifecycle reports.
// ==================================================================================

import { buildEndpoint, buildEndpointWithQuery } from '../base.endpoints';
import type { RequestReportQuery } from '../../types/das/reports.types';

const USER_BASE = '/das/reports/user';
const REQUESTS_BASE = '/das/reports/requests';

/**
 * Reports endpoints
 */
export const reportsEndpoints = {
  /**
   * Workflow Summary dashboard (U6) — no query params, all-time snapshot.
   * GET /das/reports/user/workflow-summary
   */
  getUserWorkflowSummary: () => buildEndpoint(`${USER_BASE}/workflow-summary`),

  /**
   * Paged request-lifecycle report.
   * GET /das/reports/requests?reportType=&page=&pageSize=&...
   */
  getRequestsReport: (query: RequestReportQuery) =>
    buildEndpointWithQuery(REQUESTS_BASE, query as Record<string, any>),

  /**
   * Per-approver pending-days breakdown for one request.
   * GET /das/reports/requests/{id}/pending-breakdown
   */
  getPendingBreakdown: (requestId: string) =>
    buildEndpoint(`${REQUESTS_BASE}/${requestId}/pending-breakdown`),

  /**
   * Excel export of a request-lifecycle report (full filtered set).
   * GET /das/reports/requests/export?reportType=&...
   */
  exportRequestsReport: (query: RequestReportQuery) =>
    buildEndpointWithQuery(`${REQUESTS_BASE}/export`, query as Record<string, any>),
} as const;
